import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { RefundBalanceForm } from '@/features/consumer/refund-balance-form';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/refund-balance'
)({
  component: RefundBalancePage,
});

function RefundBalancePage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/my-wallet' })}
        />
        <HeaderDashboard.Title>Refund Balance</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <RefundBalanceForm />
      </div>
    </div>
  );
}
